import React from 'react';
import './Privacy.css';

const Privacy = () => {
  return (
    <div className="container">
      <div className="card" style={{ maxWidth: '800px', margin: '40px auto', padding: '40px' }}>
        <h1 style={{ color: 'var(--primary-color)', marginBottom: '20px' }}>Privacy Policy</h1>
        
        <div style={{ color: 'var(--text-secondary)', marginBottom: '30px' }}>
          <p><strong>Effective Date:</strong> June 9, 2025</p>
          <p><strong>Last Updated:</strong> June 9, 2025</p>
        </div>

        <p style={{ marginBottom: '30px' }}>
          PrepNest ("we", "our", or "us") values your privacy. This Privacy Policy explains how we collect, use, 
          store, and protect the personal information of users ("you", "your") who visit our website and use our 
          services, including online exam registration and payments via Razorpay.
        </p>
        
        <p style={{ marginBottom: '30px' }}>
          By using our Website, you agree to the terms of this Privacy Policy.
        </p>

        <div className="privacy-section">
          <h2>1. Information We Collect</h2>
          <h3>a) Personal Information</h3>
          <p>When you register or use our services, we collect:</p>
          <ul>
            <li>Email Address (mandatory)</li>
            <li>Phone Number (optional, but recommended for support and verification)</li>
            <li>Name (if provided voluntarily)</li>
            <li>IP Address and browser/device information (automatically collected)</li>
          </ul>

          <h3>b) Payment Information</h3>
          <ul>
            <li>Payments are processed securely through Razorpay, a third-party payment gateway.</li>
            <li>We do not collect or store any card or bank account details. These are handled directly by Razorpay.</li>
          </ul>
        </div>

        <div className="privacy-section">
          <h2>2. How We Use Your Information</h2>
          <p>We use your information for:</p>
          <ul>
            <li>Creating and managing your account</li>
            <li>Allowing you to register for and take exams</li>
            <li>Sending important notifications (exam dates, results, account activity)</li>
            <li>Providing customer support</li>
            <li>Improving our website functionality and user experience</li>
            <li>Complying with legal and regulatory requirements</li>
          </ul>
          <p>We do not sell or rent your personal information to any third parties.</p>
        </div>

        <div className="privacy-section">
          <h2>3. Sharing of Information</h2>
          <p>We may share limited personal information:</p>
          <ul>
            <li>With Razorpay for payment processing (as per their policies)</li>
            <li>With service providers or partners strictly for operating our services (e.g., email or SMS services)</li>
            <li>With law enforcement or regulators, if required by law or to protect our rights</li>
          </ul>
          <p>All such third parties are required to maintain confidentiality and data security.</p>
        </div>

        <div className="privacy-section">
          <h2>4. Data Storage and Security</h2>
          <ul>
            <li>Your data is stored securely on AWS or equivalent cloud infrastructure within India or compliant jurisdictions.</li>
            <li>We use SSL encryption, access control, and other industry-standard security measures to protect your information.</li>
            <li>Only authorized personnel can access your personal data.</li>
          </ul>
        </div>

        <div className="privacy-section">
          <h2>5. Cookies and Tracking Technologies</h2>
          <p>We may use cookies and similar technologies to:</p>
          <ul>
            <li>Maintain user sessions</li>
            <li>Analyze website traffic and performance</li>
            <li>Enhance user experience</li>
          </ul>
          <p>You can control cookie preferences through your browser settings.</p>
        </div>

        <div className="privacy-section">
          <h2>6. Children's Privacy</h2>
          <p>
            Our services are intended for students, and we encourage parental oversight for users under the age of 18. 
            We do not knowingly collect more data than necessary from children. Parents may contact us to review or 
            delete their child's information.
          </p>
        </div>

        <div className="privacy-section">
          <h2>7. Data Retention</h2>
          <p>We retain your personal information only as long as necessary to:</p>
          <ul>
            <li>Provide our services</li>
            <li>Comply with legal obligations</li>
            <li>Resolve disputes and enforce our agreements</li>
          </ul>
          <p>You may request deletion of your account and data by emailing us (see Contact section).</p>
        </div>

        <div className="privacy-section">
          <h2>8. Your Rights</h2>
          <p>As a user, you have the right to:</p>
          <ul>
            <li>Access the personal data we hold about you</li>
            <li>Request correction or deletion of your information</li>
            <li>Withdraw consent at any time (may impact your access to services)</li>
            <li>File a complaint with relevant data protection authorities in India</li>
          </ul>
        </div>

        <div className="privacy-section">
          <h2>9. Third-Party Links</h2>
          <p>
            Our Website may contain links to third-party websites (e.g., Razorpay). We are not responsible for 
            the privacy practices or content of those websites. Please read their privacy policies separately.
          </p>
        </div>

        <div className="privacy-section">
          <h2>10. Changes to This Policy</h2>
          <p>
            We may update this Privacy Policy from time to time. Changes will be posted on this page with a 
            revised "Last Updated" date. Continued use of our services after such changes indicates your acceptance.
          </p>
        </div>

        <div className="privacy-section">
          <h2>11. Contact Us</h2>
          <p>For any privacy-related questions, concerns, or data access requests, please contact:</p>
          <p>📧 prepnest.2025@gmail.com</p>
          <p>📞 +91-9014716089</p>
        </div>

        <p style={{ marginTop: '40px', fontStyle: 'italic' }}>
          By using our Website, you acknowledge that you have read and understood this Privacy Policy.
        </p>
      </div>
    </div>
  );
};

export default Privacy; 